import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "shell/app/app";
import { BrowserRouter } from "react-router-dom";
import { useStore } from "shell/store/store";

const setLanguage = () => {
  const pathSplit = window.location.pathname.replace(/^\/|\/$/g, "").split("/");
  let _lang = "de";
  const browserLang = navigator.language;
  if (browserLang.indexOf("fr") !== -1) {
    _lang = "fr";
  }
  if (pathSplit[0] === "de" || pathSplit[0] === "fr") {
    _lang = pathSplit[0];
    if (pathSplit.length < 2 && _lang === "fr") {
      window.history.replaceState({}, "", "/" + _lang + "/epic");
    }
  } else {
    window.history.replaceState({}, "", "/" + _lang + "/" + (_lang === 'fr' && 'epic'));
  }
  useStore.setState({ language: _lang });
  return _lang;
};


ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={setLanguage()}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// console.log('code by studio rocani - www.rocani.net')
